import { configureStore } from '@reduxjs/toolkit'
import homeReducer from "./slice/Home"

export const store = configureStore({
  reducer: {
    homeContent:homeReducer,
  },
})